module.exports = __webpack_public_path__ + "static/media/logout.87975974.svg";